import { Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import WhiteCard from "src/components/WhiteCard";
import AddIcon from "@mui/icons-material/Add";
import { useManageModal } from "src/hooks/useManageModal";
import { RemoveCircle } from "@mui/icons-material";
import {
  useGetEmployeeRolesQuery,
  useRemoveRoleMutation,
} from "src/api/services/employeeApi";
import CreateUserRolesModal from "src/components/Modals/CreateUserRoles";
import { useCallback, useMemo } from "react";
import { UserRole } from "src/api/types";

interface Props1 {
  role: UserRole;
}

const EmployeeRole = ({ role }: Props1) => {
  const [removeRole] = useRemoveRoleMutation();

  const handleRemove = useCallback(() => {
    removeRole({ user_id: role.user_id, role_id: role.id });
  }, [removeRole, role.id, role.user_id]);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography key={role.id}>{role.role.name}</Typography>
      <Tooltip title="Remove">
        <IconButton color="error" onClick={handleRemove}>
          <RemoveCircle />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

interface Props {
  userId: string;
}

const EmployeeRoles = ({ userId }: Props) => {
  const [open, { handleOpen, handleClose }] = useManageModal();
  const { data: userRoles = [] } = useGetEmployeeRolesQuery(userId);

  const currentRoles = useMemo(() => {
    return userRoles.map((r) => r.role.name);
  }, [userRoles]);

  const key = useMemo(() => {
    return currentRoles.join(",");
  }, [currentRoles]);

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="subtitle2">USER ROLES</Typography>
          <Button
            variant="text"
            sx={{ alignSelf: "start" }}
            onClick={handleOpen}
            startIcon={<AddIcon />}
          >
            Create
          </Button>
        </Stack>
        <Stack>
          {userRoles.map((r) => (
            <EmployeeRole role={r} key={r.id} />
          ))}
        </Stack>
      </WhiteCard>
      <CreateUserRolesModal
        key={key}
        onClose={handleClose}
        open={open}
        currentRoles={currentRoles}
        userId={userId}
      />
    </>
  );
};

export default EmployeeRoles;
